<template>
  <h1>Ничего не найдено для отображения</h1>
</template>

<script>
export default {}
</script>

<style scoped>
  h1 {
    font-size: 20px;
    color: #666;
    font-family: Verdana,sans-serif;
    letter-spacing: -1px;
    font-weight: normal;
  }
</style>
